import { render, staticRenderFns } from "./refund-button.vue?vue&type=template&id=511c2308"
import script from "./refund-button.vue?vue&type=script&lang=ts"
export * from "./refund-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('511c2308')) {
      api.createRecord('511c2308', component.options)
    } else {
      api.reload('511c2308', component.options)
    }
    module.hot.accept("./refund-button.vue?vue&type=template&id=511c2308", function () {
      api.rerender('511c2308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/refund-button.vue"
export default component.exports